export default __webpack_public_path__ + "static/media/Groupe 9098.e9640636.svg";